import ShuffledText from "@/mono/components/ShuffledText";
import { wait } from "@/mono/lib/common";
import { useCSSClassTransition } from "@/mono/lib/hooks/useAnimation";
import { easeInExpo } from "@/mono/lib/styles/easing";
import { forwardRef, useImperativeHandle, useRef } from "react";
import styled from "styled-components";

const Badge = forwardRef(({ selected, children, ...props }, ref) => {
  const wrapper = useRef();
  const text = useRef();
  const { animateIn, animateOut } = useCSSClassTransition({ element: wrapper });

  useImperativeHandle(ref, () => ({
    animateIn: async ({ delay = 0 } = {}) => {
      await wait(delay * 1000);
      animateIn();
      text.current?.animateIn({ delay: 0.2 });
    },
  }));

  return (
    <StyledBadge {...props} $selected={selected} ref={wrapper}>
      <ShuffledText
        immediate={ref ? true : false}
        text={children}
        ref={text}
      ></ShuffledText>
    </StyledBadge>
  );
});

export default Badge;

const StyledBadge = styled.div`
  border: 1px solid ${({ theme, $selected }) => theme.theme.textColor};
  padding: 10rem 30rem;
  border-radius: 10rem;

  background-color: ${({ theme, $selected }) =>
    $selected ? theme.theme.textColor : "transparent"};

  cursor: pointer;
  transform: scale(0);
  transition: transform 0.4s ${easeInExpo};

  .txt-shuffle {
    color: ${({ theme, $selected }) =>
      $selected ? theme.theme.background : theme.theme.textColor};
  }

  &.active {
    transform: scale(1);
  }
`;
